<template>
  <div>
    <div class="header-wrap">
      <div class="header container rm-l-p rm-r-p">
        <router-link to="/">
        <div class="pull-left header-left">
          <a class="logo">
            <img src="../../../assets/img/logo.png" alt="一路牛" height="38">
          </a>
        </div>
        </router-link>
        <user-list/>
      </div>
    </div>
    <div class="headline-bg">
      <div id="waves" class="waves"></div>
    </div>
    <div class="container rm-l-p rm-r-p" id="contents" >
      <div id="main" class="main">
        <p class="close">
        </p>
        <div class="dashboard-func ">
          <div class="pull-left fill">
            <div class="app-fill">
              <span class="select" >消息中心</span>
            </div>
          </div>
        </div>
        <div>
          <section class="pull-left col-sm-10 profile-views">
            <div class="title-bar">
              <a class="tag-read-btn">全部标记为已读</a>
            </div>
            <el-table
              :data="tableData.records"
              style="width: 100%"
              :show-header="false"
              :row-class-name="rowClassName"
              @row-click="selectTable">
              <el-table-column
                prop="date"
                width="170px">
                <template slot-scope="scope">
                    <span><i class="dot" v-if="scope.row.isRead ===0"></i> {{ new Date(scope.row.date).format('yyyy-MM-dd HH:mm') }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="content"
                width="550px"
                :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.content }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="right">
                <template slot-scope="scope" v-if="scope.row.type ===2">
                  <div v-if="scope.row.isDo === 0">
                    <el-button
                      size="mini"
                      plain
                      type="success"
                      @click="agree(scope.$index, scope.row)">同意</el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      plain
                      @click="disagree(scope.$index, scope.row)">拒绝</el-button>
                  </div>
                  <el-tag type="info" size="small" v-if="scope.row.isDo === 1">已同意</el-tag>
                  <el-tag type="info" size="small" v-if="scope.row.isDo === 2">已拒绝</el-tag>
                </template>
              </el-table-column>
            </el-table>
          </section>
        </div>
    </div>
  </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import userList from '../../layout/userList'
import { getMsgList, isRead, isDo } from '../../../api/message'

export default {
  data () {
    return {
      tableData: '',
      search: {
        current: 1,
        pageSize: 15
      }
    }
  },
  computed: {
    ...mapGetters({userInfo: 'user/userInfo'})
  },
  created () {
    let _this = this
    getMsgList(this.search).then(response => {
      _this.tableData = response.data.data
    })
  },
  methods: {
    selectTable (row) {
      if (row.isRead === 0) {
        row.isRead = 1
        isRead(row.messageId)
      }
    },
    agree (index, row) {
      row.name = this.userInfo.user.userName
      row.isDo = 1
      isDo(row)
    },
    disagree (index, row) {
      row.name = this.userInfo.user.userName
      row.isDo = 2
      isDo(row)
    },
    rowClassName ({row, rowIndex}) {
      if (row.isRead === 0) {
        return 'noRead'
      }
    }
  },
  components: {
    userList
  }
}
</script>
<style  lang="stylus" rel="stylesheet/stylus">
  .dot
    background-color: #f56c6c
    border-radius: 50%
    color: #fff
    display: inline-block
    font-size: 12px
    width 8px
    height: 8px
    line-height: 18px
    padding: 0
    text-align: center
    white-space: nowrap
    border: 1px solid #fff
    position absolute
    top: 5px;
    left: -10px;
  .container
    .noRead
      color #000
      font-weight 500
      cursor pointer
      span
       position relative
    .profile-views
      width 980px
      padding 35px
      border 1px solid #EEE
      box-shadow 0 0 5px 0 rgba(215,215,215,.5)
      .title-bar
        width: 100%
        height: 50px
        background: #f3f5f7
        font-family: "微软雅黑"
        font-size: 14px
        line-height: 50px
        color: #93999f
        border-top: 1px solid #b7bbbf
        .tag-read-btn
          float: right
          margin-right: 20px
          color: #4d555d
      .profile-title
        color #333
        letter-spacing -.63px
        font-size 24px
        line-height 24px
      .profile-views-main-info
        padding 44px 40px 0
        .content-nav
          position relative
          line-height 1
          .text-center
            cursor pointer
  .content-details
    position relative
  .info-conent
    padding-top 60px
    padding-bottom 70px
  .info-show
    position relative
  .info-binding
    border-right 1px dashed #ccc
    padding 30px 70px 70px 80px
    .info-phone
      padding-top: 12px
      font-size: 12px
      color: #999
      .info-links
        top: 3px
        margin-left: 5px
        color: #C2C2C2
        font-size 12px
    .info-avatar
      position: relative
      margin: 0 auto
      width: 120px
      height: 120px
      border-radius: 50%
      &:hover
        .avatar-upload
          opacity 1
      .avatar-edit
        top: 0
        border-radius: 50%
        border: 1px solid #ccc
        transform: rotate(45deg)
        transition: opacity .2s
        position: absolute
        width: 100%
        height: 100%
        left: 0
        .edit-icon
          position: absolute
          right: 0
          top: 50%
          margin-top: -12px
          margin-right: -12px
          transform: rotate(-45deg)
      .avatar-upload
        top: 0
        padding-top: 30px
        border-radius: 50%
        background-color: rgba(42,45,47,.8)
        cursor: pointer
        opacity 0
        transition: opacity .2s
        position: absolute
        width: 100%
        height: 100%
        left: 0
        .avatar-edit-tips
          display: block
          color: #fff
          line-height: 35px
      .img-circle
        border-radius: 50%
  .info-subjoin-item
    padding-left: 58px
    padding-top: 20px
    position: absolute
    right: 0
    width: 507px
    .info-item
      font-size: 16px
      color: #777
      padding-bottom: 30px
      display: block
      position: relative
      .info-item-name
        margin: 0
        font-weight: 300
        letter-spacing: 0
        font-size: 16px
        color: #777
        .user-name
          font-size: 16px
          scolor: #777
</style>
